import { createStyles } from '@dailyshot/core';

interface NotificationsStylesParams {
  zIndex: React.CSSProperties['zIndex'];
}

export default createStyles((theme, { zIndex }: NotificationsStylesParams) => ({
  notifications: {
    width: `calc(100% - ${theme.spacing.md} * 2)`,
    boxSizing: 'border-box',
    position: 'fixed',
    zIndex: zIndex as number,
  },

  notification: {
    '&:not(:first-of-type)': {
      marginTop: theme.spacing.sm,
    },
  },
}));
